import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Row, Col, Spin } from 'antd'
import { useParams } from 'react-router-dom'
import { getTracpatchExerciseResults } from '../../../store/action/patient.action'
import TracPatchExerciseChart from './tracpatch.exercise.chart'
import TracPatchExerciseRepsChart from './tracpatch.exercise.reps.chart'
import '../../../css/patient.scss'

const TracPatchExercises = (props) => {
  const [loading, setLoading] = useState(true)
  const [records, setRecords] = useState([])
  const params = useParams()

  useEffect(() => {
    let mounted = true
    const load = async () => {
      setLoading(true)
      const res = await props.getTracpatchExerciseResults(params.id)
      if (mounted) {
        setRecords((res && res.data) || [])
        setLoading(false)
      }
    }
    load()
    return () => {
      mounted = false
    }
  }, [params.id])

  const grouped = {}
  records.forEach((r) => {
    const key = r.exerciseId != null ? String(r.exerciseId) : (r.exerciseName || 'unknown')
    if (!grouped[key]) grouped[key] = []
    grouped[key].push(r)
  })
  const groupKeys = Object.keys(grouped)

  if (loading) {
    return (
      <Row justify='center' align='middle' style={{ height: 200 }}>
        <Spin />
      </Row>
    )
  }

  if (groupKeys.length === 0) {
    return (
      <Row justify='center' align='middle' style={{ height: 200 }}>
        <h3>No TracPatch exercise data yet.</h3>
      </Row>
    )
  }

  return (
    <div>
      {groupKeys.map((key) => {
        const group = grouped[key]
        const exerciseName = group[0].exerciseName || 'TracPatch Exercise'
        return (
          <Row key={key} style={{ marginBottom: 16 }} gutter={16}>
            <Col span={12} className='chartContainer' style={{ padding: 12 }}>
              <TracPatchExerciseChart data={group} exerciseName={exerciseName} />
            </Col>
            <Col span={12} className='chartContainer' style={{ padding: 12 }}>
              <TracPatchExerciseRepsChart data={group} exerciseName={exerciseName} />
            </Col>
          </Row>
        )
      })}
    </div>
  )
}

const mapStateToProps = (state) => ({ patient: state.patient.patient })
const mapDispatchToProps = (dispatch) => ({
  getTracpatchExerciseResults: (id, exerciseId, startDate, endDate) =>
    dispatch(getTracpatchExerciseResults(id, exerciseId, startDate, endDate)),
})

export default connect(mapStateToProps, mapDispatchToProps)(TracPatchExercises)
